/* SOOMOM guest returns/exchanges wizard.
   Spec: docs/guest-returns-frontend-spec.md  (API base = account.soomom.com)
   Phase 1: ① verify + ② select items.
   Phase 2: ③ exchange-search (per exchange line) + ④ preview (review page).
   Phase 3 (todo): ⑤ submit + confirmation.  Phase 4 (todo): tracking page. */
(function () {
  var root = document.querySelector('[data-guest-returns-root]');
  if (!root) return;
  var API = (root.getAttribute('data-api-base') || 'https://account.soomom.com').replace(/\/+$/, '');
  var form = root.querySelector('[data-guest-returns]');
  var step1 = root.querySelector('[data-returns-step1]');
  var err1 = root.querySelector('[data-returns-error]');
  var stepsBox = root.querySelector('[data-returns-steps]');
  if (!form || form.dataset.bound || !stepsBox) return;
  form.dataset.bound = '1';

  // state carried across steps; token refreshed on every API response
  var S = { token: null, orderName: '', currency: 'AUD', lines: [], questions: [], brand: null,
            picks: {} /* lineItemId -> {variantId, price, title} for exchange lines */ };

  var REASONS = [
    { code: 'size', label: "Size doesn't fit" },
    { code: 'damaged', label: 'Damaged' },
    { code: 'changed_mind', label: 'Changed my mind' },
    { code: 'wrong_item', label: 'Wrong item' },
    { code: 'not_as_described', label: 'Not as described' }
  ];
  var REFUND_METHODS = [
    { code: 'STORE_CREDIT', label: 'Store credit' },
    { code: 'ORIGINAL', label: 'Original payment' },
    { code: 'DISCOUNT_CODE', label: 'Discount code' }
  ];

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(n) { return S.currency + ' ' + (Number(n) || 0).toFixed(2); }
  function reasonLabel(code) { var r = REASONS.find(function (x) { return x.code === code; }); return r ? r.label : code; }
  function notReturnableText(code) {
    return ({
      EXCLUDED_TAG: "This item isn't eligible for return.",
      EXCLUDED_COLLECTION: "This item isn't eligible for return.",
      EXCLUDED_PRODUCT: "This item isn't eligible for return.",
      WINDOW_CLOSED: 'The return window has closed for this item.'
    })[code] || "This item isn't eligible for return.";
  }
  function show(el, msg) { if (el) { el.hidden = false; el.textContent = msg; } }
  function hide(el) { if (el) { el.hidden = true; el.textContent = ''; } }

  function api(path, body) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    });
  }

  // session (30-min token) expired anywhere → bounce back to step ①
  function sessionExpired() {
    stepsBox.innerHTML = '';
    if (step1) step1.hidden = false;
    show(err1, 'Your session has expired. Please look up your order again.');
    try { step1.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  // ----------------------------------------------------------------- ① verify
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hide(err1);
    var order = (form.order.value || '').trim();
    var email = (form.email.value || '').trim();
    if (!order || !email) return;
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Checking…'; }

    api('/api/guest/verify', { orderNumber: order, email: email })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        var d = res.body || {};
        if (res.status === 200 && d.ok) {
          S.token = d.token; S.orderName = d.orderName || order;
          S.currency = d.currency || 'AUD';
          S.lines = Array.isArray(d.lines) ? d.lines : [];
          S.questions = Array.isArray(d.questions) ? d.questions : [];
          S.brand = d.brand || null; S.picks = {};
          renderSelect();
        } else if (d.code === 'rate_limited') {
          show(err1, d.error || 'Too many attempts. Please try again later.');
        } else {
          show(err1, d.error || 'Order number or email is incorrect.');
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        show(err1, 'Something went wrong. Please try again shortly.');
      });
  });

  // ------------------------------------------------------------- ② select items
  function lineControls(ln) {
    var h = '<div class="gr-ctl-grid">';
    if (ln.quantity > 1) {
      h += '<label class="gr-ctl-field"><span>Quantity</span><select class="gr-qty">';
      for (var q = 1; q <= ln.quantity; q++) h += '<option value="' + q + '">' + q + '</option>';
      h += '</select></label>';
    }
    h += '<label class="gr-ctl-field"><span>Reason</span><select class="gr-reason"><option value="" disabled selected>Choose a reason…</option>';
    REASONS.forEach(function (r) { h += '<option value="' + r.code + '">' + esc(r.label) + '</option>'; });
    h += '</select></label></div>';
    h += '<div class="gr-res"><span class="gr-ctl-lbl">Resolution</span>'
      + '<label class="gr-res-opt"><input type="radio" name="res-' + esc(ln.lineItemId) + '" value="refund" checked /> Refund</label>'
      + '<label class="gr-res-opt"><input type="radio" name="res-' + esc(ln.lineItemId) + '" value="exchange" /> Exchange</label>'
      + '</div>';
    // ③ exchange-search panel (shown only when "exchange" is chosen)
    h += '<div class="gr-exchange" data-exchange hidden>'
      + '<div class="gr-ex-search"><input type="text" class="gr-ex-query" placeholder="Search a replacement (e.g. bib shorts)…" />'
      + '<button type="button" class="gr-ex-go">Search</button></div>'
      + '<div class="gr-ex-results" data-ex-results></div>'
      + '<div class="gr-ex-picked" data-ex-picked hidden></div>'
      + '</div>';
    return h;
  }

  function refundMethodHtml() {
    var h = '<div class="gr-field"><span class="gr-label">How would you like your refund?</span><div class="gr-rm">';
    REFUND_METHODS.forEach(function (m, i) {
      h += '<label class="gr-rm-opt"><input type="radio" name="gr-refund-method" value="' + m.code + '"' + (i === 0 ? ' checked' : '') + ' /> ' + esc(m.label) + '</label>';
    });
    return h + '</div></div>';
  }

  function questionsHtml() {
    if (!S.questions.length) return '';
    var h = '<div class="gr-questions">';
    S.questions.forEach(function (q) {
      h += '<div class="gr-field" data-q="' + esc(q.id) + '"><label class="gr-label">' + esc(q.label) + (q.required ? ' <span class="gr-req">*</span>' : '') + '</label>';
      if (q.type === 'select') {
        h += '<select class="gr-q-input"><option value="" disabled selected>Choose…</option>';
        (q.options || []).forEach(function (o) { h += '<option value="' + esc(o) + '">' + esc(o) + '</option>'; });
        h += '</select>';
      } else {
        h += '<input type="text" class="gr-q-input" />';
      }
      h += '</div>';
    });
    return h + '</div>';
  }

  function renderSelect() {
    var h = '<div class="gr-card" data-step2-card>';
    h += '<span class="gr-eb">Step 2</span><h3 class="gr-h">Choose what to return.</h3>';
    h += '<p class="gr-sub">Order <strong>' + esc(S.orderName) + '</strong>. Select the items and tell us why.</p>';
    h += '<div class="gr-lines">';
    if (!S.lines.length) h += '<p class="gr-empty">There are no items eligible for return on this order.</p>';
    S.lines.forEach(function (ln) {
      var dis = !ln.returnable;
      h += '<div class="gr-line' + (dis ? ' is-disabled' : '') + '" data-line="' + esc(ln.lineItemId) + '">';
      h += '<label class="gr-line-head"><input type="checkbox" class="gr-check"' + (dis ? ' disabled' : '') + ' /><span class="gr-line-main">';
      h += '<span class="gr-line-title">' + esc(ln.title) + '</span>';
      var sub = [ln.variantTitle, ln.sku].filter(Boolean).map(esc).join(' · ');
      if (sub) h += '<span class="gr-line-sub">' + sub + '</span>';
      h += '<span class="gr-line-meta">' + money(ln.refundValue) + ' · Qty ' + ln.quantity + '</span>';
      if (dis && ln.notReturnableReason) h += '<span class="gr-line-flag">' + esc(notReturnableText(ln.notReturnableReason)) + '</span>';
      if (!dis && ln.keepItem) h += '<span class="gr-line-flag">Keep the item — no need to ship it back.</span>';
      if (!dis && !ln.freeReturnShipping) h += '<span class="gr-line-flag">Return shipping is at your cost.</span>';
      h += '</span></label><div class="gr-line-ctl" hidden>' + lineControls(ln) + '</div></div>';
    });
    h += '</div>';
    h += '<div class="gr-field"><label class="gr-label">Tell us a bit more <span class="gr-req">*</span></label>'
      + '<textarea class="gr-comment" rows="3" placeholder="A short note about your return…"></textarea></div>';
    h += refundMethodHtml() + questionsHtml();
    h += '<div class="gr-error" data-step2-error hidden></div>';
    h += '<div class="gr-actions"><button type="button" class="gr-btn gr-btn--ghost" data-back>← Start over</button>'
      + '<button type="button" class="gr-btn" data-to-review>Continue to review →</button></div>';
    h += '</div>';
    stepsBox.innerHTML = h;
    bindSelect();
    try { stepsBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  function bindSelect() {
    stepsBox.querySelectorAll('.gr-line').forEach(function (row) {
      var id = row.getAttribute('data-line');
      var check = row.querySelector('.gr-check');
      var ctl = row.querySelector('.gr-line-ctl');
      var exPanel = row.querySelector('[data-exchange]');
      if (!check || !ctl) return;
      check.addEventListener('change', function () {
        ctl.hidden = !check.checked;
        row.classList.toggle('is-selected', check.checked);
      });
      // refund/exchange toggle → show/hide exchange search; clear pick when leaving exchange
      ctl.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          var isEx = r.value === 'exchange' && r.checked;
          if (exPanel) exPanel.hidden = !isEx;
          if (!isEx) { delete S.picks[id]; var pk = row.querySelector('[data-ex-picked]'); if (pk) { pk.hidden = true; pk.innerHTML = ''; } var rr = row.querySelector('[data-ex-results]'); if (rr) rr.innerHTML = ''; }
        });
      });
      // ③ search wiring
      var go = row.querySelector('.gr-ex-go');
      var qEl = row.querySelector('.gr-ex-query');
      var resultsEl = row.querySelector('[data-ex-results]');
      if (go && qEl && resultsEl) {
        go.addEventListener('click', function () { exchangeSearch(row, id); });
        qEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); exchangeSearch(row, id); } });
        resultsEl.addEventListener('click', function (e) {
          var chip = e.target.closest('.gr-chip');
          if (!chip || chip.disabled) return;
          S.picks[id] = { variantId: chip.getAttribute('data-vid'), price: parseFloat(chip.getAttribute('data-price')), title: chip.getAttribute('data-title') };
          resultsEl.querySelectorAll('.gr-chip').forEach(function (b) { b.classList.toggle('is-picked', b === chip); });
          var picked = row.querySelector('[data-ex-picked]');
          if (picked) { picked.hidden = false; picked.innerHTML = 'Replacing with <strong>' + esc(S.picks[id].title) + '</strong> — ' + money(S.picks[id].price); }
        });
      }
    });
    var back = stepsBox.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () {
      stepsBox.innerHTML = '';
      if (step1) { step1.hidden = false; try { step1.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
    });
    var next = stepsBox.querySelector('[data-to-review]');
    if (next) next.addEventListener('click', onReview);
  }

  // ③ exchange-search
  function exchangeSearch(row, lineId) {
    var qEl = row.querySelector('.gr-ex-query');
    var resultsEl = row.querySelector('[data-ex-results]');
    var query = (qEl.value || '').trim();
    if (!query) return;
    resultsEl.innerHTML = '<p class="gr-ex-msg">Searching…</p>';
    api('/api/guest/exchange-search', { token: S.token, query: query })
      .then(function (res) {
        var d = res.body || {};
        if (res.status === 401 && d.code === 'token_expired') return sessionExpired();
        if (!d.ok) { resultsEl.innerHTML = '<p class="gr-ex-msg">' + esc(d.error || 'Search failed. Try again.') + '</p>'; return; }
        S.token = d.token || S.token;
        // results are grouped by PRODUCT: { productId, title, imageUrl, variants:[{variantId,title,price,available}] }
        var products = Array.isArray(d.results) ? d.results : [];
        if (!products.length) { resultsEl.innerHTML = '<p class="gr-ex-msg">No matches — try a different search.</p>'; return; }
        var h = '';
        products.forEach(function (p) {
          var vs = Array.isArray(p.variants) ? p.variants : [];
          var inStock = vs.filter(function (v) { return v.available; }).length;
          h += '<div class="gr-prod">';
          h += '<div class="gr-prod__img">' + (p.imageUrl ? '<img src="' + esc(p.imageUrl) + '" alt="" loading="lazy" />' : '') + '</div>';
          h += '<div class="gr-prod__body"><div class="gr-prod__head"><span class="gr-prod__title">' + esc(p.title) + '</span><span class="gr-prod__stock">' + inStock + ' of ' + vs.length + ' in stock</span></div>';
          h += '<div class="gr-prod__chips">';
          vs.forEach(function (v) {
            h += '<button type="button" class="gr-chip' + (v.available ? '' : ' is-oos') + '"' + (v.available ? '' : ' disabled')
              + ' data-vid="' + esc(v.variantId) + '" data-price="' + (Number(v.price) || 0) + '" data-title="' + esc(p.title + ' — ' + v.title) + '">'
              + esc(v.title) + ' · ' + money(v.price) + '</button>';
          });
          h += '</div></div></div>';
        });
        resultsEl.innerHTML = h;
        if (S.picks[lineId]) { var b = resultsEl.querySelector('.gr-chip[data-vid="' + S.picks[lineId].variantId + '"]'); if (b) b.classList.add('is-picked'); }
      })
      .catch(function () { resultsEl.innerHTML = '<p class="gr-ex-msg">Search is unavailable right now.</p>'; });
  }

  // assemble SubmitItem[] + comment + refundMethod + answers (shared by preview & submit)
  function collect() {
    var items = [];
    var byId = {}; S.lines.forEach(function (l) { byId[l.lineItemId] = l; });
    stepsBox.querySelectorAll('.gr-line').forEach(function (row) {
      var check = row.querySelector('.gr-check');
      if (!check || !check.checked) return;
      var id = row.getAttribute('data-line');
      var qtyEl = row.querySelector('.gr-qty');
      var reasonEl = row.querySelector('.gr-reason');
      var resEl = row.querySelector('input[type="radio"]:checked');
      var resolution = resEl ? resEl.value : 'refund';
      var it = { lineItemId: id, qty: qtyEl ? parseInt(qtyEl.value, 10) : 1, reasonCode: reasonEl ? reasonEl.value : '', resolution: resolution };
      if (resolution === 'exchange' && S.picks[id]) {
        it.exchangeVariantId = S.picks[id].variantId;
        it.exchangePrice = S.picks[id].price;
        it.exchangeTitle = S.picks[id].title;
      }
      items.push(it);
    });
    var comment = (stepsBox.querySelector('.gr-comment') || {}).value || '';
    var rmEl = stepsBox.querySelector('input[name="gr-refund-method"]:checked');
    var answers = [];
    stepsBox.querySelectorAll('[data-q]').forEach(function (qEl) {
      var inp = qEl.querySelector('.gr-q-input');
      answers.push({ id: qEl.getAttribute('data-q'), answer: inp ? (inp.value || '') : '' });
    });
    return { items: items, comment: comment.trim(), refundMethod: rmEl ? rmEl.value : 'STORE_CREDIT', answers: answers };
  }

  // ④ preview → review page
  function onReview() {
    var card = stepsBox.querySelector('[data-step2-card]');
    var errBox = card.querySelector('[data-step2-error]');
    hide(errBox);
    var sel = collect();
    if (!sel.items.length) return show(errBox, 'Please select at least one item to return.');
    for (var i = 0; i < sel.items.length; i++) {
      if (!sel.items[i].reasonCode) return show(errBox, 'Please choose a reason for each selected item.');
      if (sel.items[i].resolution === 'exchange' && !sel.items[i].exchangeVariantId) return show(errBox, "Please choose a replacement product for every item you're exchanging.");
    }
    if (!sel.comment) return show(errBox, 'Please add a comment describing your return.');
    var bad = null;
    S.questions.forEach(function (q) { if (q.required) { var a = sel.answers.find(function (x) { return x.id === q.id; }); if (!a || !a.answer) bad = q.label; } });
    if (bad) return show(errBox, 'Please answer: ' + bad);

    var btn = card.querySelector('[data-to-review]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Reviewing…'; }
    api('/api/guest/preview', { token: S.token, comment: sel.comment, refundMethod: sel.refundMethod, items: sel.items, answers: sel.answers })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        var d = res.body || {};
        if (res.status === 401 && d.code === 'token_expired') return sessionExpired();
        if (!d.ok) return show(errBox, d.error || 'Please review your selections and try again.');
        S.token = d.token || S.token;
        if (d.currency) S.currency = d.currency;
        S.lastSel = sel; // kept for ⑤ submit (Phase 3)
        renderReview(d);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } show(errBox, 'Review is temporarily unavailable. Please try again shortly.'); });
  }

  function renderReview(d) {
    var card = stepsBox.querySelector('[data-step2-card]');
    if (card) card.style.display = 'none';
    var refunds = d.refundItems || [];
    var exchanges = d.exchangeItems || [];
    var h = '<div class="gr-card" data-review-card><span class="gr-eb">Step 3</span><h3 class="gr-h">Review your return.</h3>';
    h += '<p class="gr-sub">Order <strong>' + esc(S.orderName) + '</strong>. Totals are calculated by SOOMOM.</p>';

    if (refunds.length) {
      h += '<div class="gr-rev-group"><div class="gr-rev-gh">Refunds</div>';
      refunds.forEach(function (it) {
        h += '<div class="gr-rev-item"><div class="gr-rev-main"><div class="gr-rev-title">' + esc(it.title) + '</div>'
          + '<div class="gr-rev-sub">Qty ' + it.qty + ' · ' + esc(it.reasonLabel || reasonLabel(it.reasonCode)) + (it.freeReturnShipping ? '' : ' · ship at your cost') + '</div></div>'
          + '<div class="gr-rev-amt">' + money(it.lineRefund) + '</div></div>';
      });
      h += '</div>';
    }
    if (exchanges.length) {
      h += '<div class="gr-rev-group"><div class="gr-rev-gh">Exchanges</div>';
      exchanges.forEach(function (it) {
        h += '<div class="gr-rev-item"><div class="gr-rev-main"><div class="gr-rev-title">' + esc(it.title) + ' → ' + esc(it.exchangeTitle) + '</div>'
          + '<div class="gr-rev-sub">Qty ' + it.qty + ' · ' + esc(it.reasonLabel || reasonLabel(it.reasonCode)) + ' · new ' + money(it.exchangePrice) + (it.freeReturnShipping ? '' : ' · ship at your cost') + '</div></div>'
          + '<div class="gr-rev-amt">' + money(it.exchangeLineTotal) + '</div></div>';
      });
      h += '</div>';
    }

    h += '<div class="gr-summary">';
    h += '<div class="gr-sum-row"><span>Refund total</span><b>' + money(d.refundTotal) + '</b></div>';
    if (Number(d.exchangePay) > 0) h += '<div class="gr-sum-row gr-sum-pay"><span>To pay now (exchange difference)</span><b>' + money(d.exchangePay) + '</b></div>';
    if (Number(d.exchangeCredit) > 0) h += '<div class="gr-sum-row"><span>Store credit back</span><b>' + money(d.exchangeCredit) + '</b></div>';
    h += '</div>';
    if (d.anySelfShip) h += '<p class="gr-warn">Some items don’t include a free return label — you’ll cover return shipping for those.</p>';

    h += '<div class="gr-error" data-review-error hidden></div>';
    h += '<div class="gr-actions"><button type="button" class="gr-btn gr-btn--ghost" data-edit>← Edit selections</button>'
      + '<button type="button" class="gr-btn" data-submit>' + (Number(d.exchangePay) > 0 ? 'Submit & pay ' + money(d.exchangePay) + ' →' : 'Submit return →') + '</button></div>';
    h += '</div>';

    var wrap = document.createElement('div');
    wrap.innerHTML = h;
    stepsBox.appendChild(wrap.firstChild);
    bindReview();
    try { stepsBox.querySelector('[data-review-card]').scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  function bindReview() {
    var rev = stepsBox.querySelector('[data-review-card]');
    var edit = rev.querySelector('[data-edit]');
    if (edit) edit.addEventListener('click', function () {
      rev.remove();
      var card = stepsBox.querySelector('[data-step2-card]');
      if (card) { card.style.display = ''; try { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
    });
    var submit = rev.querySelector('[data-submit]');
    if (submit) submit.addEventListener('click', function () { onSubmit(rev, submit); });
  }

  // ----------------------------------------------------------------- ⑤ submit
  function onSubmit(rev, btn) {
    var errBox = rev.querySelector('[data-review-error]');
    hide(errBox);
    if (!S.lastSel) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Submitting…';
    api('/api/guest/submit', {
      token: S.token,
      comment: S.lastSel.comment,
      refundMethod: S.lastSel.refundMethod,
      items: S.lastSel.items,
      answers: S.lastSel.answers
    }).then(function (res) {
      var d = res.body || {};
      if (res.status === 401 && d.code === 'token_expired') return sessionExpired();
      if (res.status === 409 && d.code === 'already_exists') {
        btn.disabled = false; btn.textContent = orig;
        var rma = d.existingTrackingCode ? ' (' + esc(d.existingTrackingCode) + ')' : '';
        show(errBox, (d.error || 'You already have a return in progress for this order') + rma + '. Use that code to track it.');
        return;
      }
      if (!d.ok) { btn.disabled = false; btn.textContent = orig; show(errBox, d.error || 'Could not submit your return. Please try again.'); return; }
      renderConfirm(d);
    }).catch(function () {
      btn.disabled = false; btn.textContent = orig;
      show(errBox, 'Submit is temporarily unavailable. Please try again shortly.');
    });
  }

  function renderConfirm(d) {
    var pay = (Number(d.payAmount) > 0) && d.payUrl;
    var cur = d.currency || S.currency;
    var amt = cur + ' ' + (Number(d.payAmount) || 0).toFixed(2);
    var code = esc(d.trackingCode || '');
    var h = '<div class="gr-card gr-confirm">';
    h += '<span class="gr-eb">All done</span>';
    h += '<h3 class="gr-h">Your return is requested.</h3>';
    h += '<p class="gr-sub">We’ve emailed your confirmation with all the details.</p>';
    h += '<div class="gr-rma"><span class="gr-rma-lbl">Your return reference</span><span class="gr-rma-code">' + code + '</span></div>';
    if (pay) {
      h += '<div class="gr-confirm-pay"><p>An exchange balance of <strong>' + esc(amt) + '</strong> is due to complete your exchange.</p>'
        + '<a class="gr-btn" href="' + esc(d.payUrl) + '">Pay ' + esc(amt) + ' now →</a></div>';
    }
    h += '<p class="gr-confirm-note">Keep <strong>' + code + '</strong> handy — you can track your return status anytime with it.</p>';
    h += '<div class="gr-actions gr-actions--center"><button type="button" class="gr-btn gr-btn--ghost" data-track-now>Track this return →</button></div>';
    h += '</div>';
    stepsBox.innerHTML = h;
    var tn = stepsBox.querySelector('[data-track-now]');
    if (tn) tn.addEventListener('click', function () { openTracker(d.trackingCode); });
    try { stepsBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  // ============ P4: track an existing return (GET by RMA code, no token) ============
  var TRACK_STEPS = ['REQUESTED', 'APPROVED', 'LABEL_SENT', 'IN_TRANSIT', 'RECEIVED', 'REFUNDED'];
  var TRACK_LABELS = { REQUESTED: 'Requested', APPROVED: 'Approved', LABEL_SENT: 'Label sent', IN_TRANSIT: 'In transit', RECEIVED: 'Received', REFUNDED: 'Refunded', REJECTED: 'Rejected' };

  function trackerApi() {
    var trk = document.querySelector('[data-returns-tracker]');
    return (((trk && trk.getAttribute('data-api-base')) || API || 'https://account.soomom.com')).replace(/\/+$/, '');
  }

  function loadTracking(code, terr, tout, tform) {
    hide(terr);
    tout.innerHTML = '<p class="gr-track-msg">Looking up your return…</p>';
    var btn = tform ? tform.querySelector('button[type="submit"]') : null;
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Tracking…'; }
    fetch(trackerApi() + '/api/guest/returns/' + encodeURIComponent(code))
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        var d = res.body || {};
        if (res.status === 404 || !d.ok) { tout.innerHTML = ''; show(terr, (d && d.error) || 'Return request not found.'); return; }
        renderTracking(d, tout);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } tout.innerHTML = ''; show(terr, 'Tracking is temporarily unavailable. Please try again shortly.'); });
  }

  function renderTracking(d, tout) {
    var r = d.ret || {};
    var cur = r.currency || 'AUD';
    function m2(v) { return (v == null) ? null : cur + ' ' + (Number(v) || 0).toFixed(2); }
    var h = '<div class="gr-track-card"><div class="gr-track-head"><span class="gr-track-lbl">Return</span><span class="gr-track-code">' + esc(r.trackingCode || '') + '</span>';
    if (d.orderName) h += '<span class="gr-track-order">Order ' + esc(d.orderName) + '</span>';
    h += '</div>';
    if (r.status === 'REJECTED') {
      h += '<p class="gr-track-rejected">This return was not approved. Please contact support if you have questions.</p>';
    } else {
      var ci = TRACK_STEPS.indexOf(r.status);
      h += '<ol class="gr-track-tl">';
      TRACK_STEPS.forEach(function (st, i) {
        var done = ci >= 0 && i <= ci;
        h += '<li class="gr-tl-step' + (done ? ' is-done' : '') + (i === ci ? ' is-now' : '') + '"><span class="gr-tl-dot"></span><span class="gr-tl-name">' + esc(TRACK_LABELS[st]) + '</span></li>';
      });
      h += '</ol>';
    }
    h += '<div class="gr-track-meta">';
    if (m2(r.refundAmount)) h += '<div class="gr-sum-row"><span>Refund</span><b>' + m2(r.refundAmount) + '</b></div>';
    if (r.priceDifference != null) {
      var pd = Number(r.priceDifference);
      h += '<div class="gr-sum-row"><span>' + (pd < 0 ? 'Store credit back' : 'Exchange difference') + '</span><b>' + cur + ' ' + Math.abs(pd).toFixed(2) + '</b></div>';
    }
    if (r.trackingNumber) h += '<div class="gr-sum-row"><span>Parcel tracking #</span><b>' + esc(r.trackingNumber) + '</b></div>';
    h += '</div>';
    if (r.hasLabel) h += '<a class="gr-btn" href="' + esc(trackerApi() + '/api/guest/returns/' + encodeURIComponent(r.trackingCode || '') + '/label') + '">Download return label →</a>';
    if (Array.isArray(r.items) && r.items.length) {
      h += '<div class="gr-track-items"><div class="gr-rev-gh">Items</div>';
      r.items.forEach(function (it) { h += '<div class="gr-track-item">' + (it.qty || 1) + ' &times; ' + esc(it.reason || 'item') + '</div>'; });
      h += '</div>';
    }
    tout.innerHTML = h + '</div>';
  }

  function openTracker(code) {
    var trk = document.querySelector('[data-returns-tracker]');
    if (!trk) return;
    var body = trk.querySelector('[data-track-body]');
    var tform = trk.querySelector('[data-rma-form]');
    if (body) body.hidden = false;
    if (tform && tform.rma) tform.rma.value = code;
    loadTracking(code, trk.querySelector('[data-track-error]'), trk.querySelector('[data-track-result]'), tform);
    try { trk.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  function initTracker() {
    var trk = document.querySelector('[data-returns-tracker]');
    if (!trk || trk.dataset.bound) return;
    trk.dataset.bound = '1';
    var toggle = trk.querySelector('[data-track-toggle]');
    var body = trk.querySelector('[data-track-body]');
    var tform = trk.querySelector('[data-rma-form]');
    var terr = trk.querySelector('[data-track-error]');
    var tout = trk.querySelector('[data-track-result]');
    if (toggle && body) toggle.addEventListener('click', function () { body.hidden = !body.hidden; });
    if (tform) tform.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (tform.rma.value || '').trim();
      if (code) loadTracking(code, terr, tout, tform);
    });
    var m = location.search.match(/[?&]rma=([^&]+)/i);
    if (m && tform) {
      var code = decodeURIComponent(m[1]);
      if (body) body.hidden = false;
      if (tform.rma) tform.rma.value = code;
      loadTracking(code, terr, tout, tform);
    }
  }
  initTracker();
})();
